<template>
  <div>
    <b-button variant="success" class="float-right mb-4" v-b-modal.benutzerAnlegen @click="resetAdminBenutzerData"><font-awesome-icon icon="plus"/> Hinzufügen</b-button>
    <b-table striped small responsive outlined :items="alleBenutzer" :fields="fields">
      <template v-slot:cell(karte)="data">
        <a
                :href="`https://www.google.com/maps/place/ + ${data.item.lat} + N, + ${data.item.lng} + E`"
                target="_blank"
                class="btn btn-info btn-sm text-white"
        >Karte</a>
      </template>
      <template v-slot:cell(active)="data">
        <b-form-checkbox
                :id="`isactive-checkbox-${data.item.id}`"
                v-model="data.item.isActive"
                :name="`isactive-checkbox-${data.item.id}`"
                value="1"
                unchecked-value="0"
                disabled
        />
      </template>
      <template v-slot:cell(isAdmin)="data">
        <b-form-checkbox
                :id="`admin-checkbox-${data.item.id}`"
                v-model="data.item.admin"
                :name="`admin-checkbox-${data.item.id}`"
                value="1"
                unchecked-value="0"
                disabled=""
        />
      </template>
      <template v-slot:cell(buttons)="data">
        <b-button-group>
          <b-button
              @click="updBenutzer(data.item)"
          >Bearbeiten</b-button>
        </b-button-group>
      </template>
    </b-table>

    <b-modal id="benutzerBearbeiten" title="Benutzer Bearbeiten" size="xl" header-bg-variant="secondary" header-text-variant="white" hide-footer>
      <BenutzerKontoBearbeiten :benutzer="benutzer" @updateUserToast="emitToast"/>
    </b-modal>
    <b-modal id="benutzerAnlegen" title="Benutzer Anlegen" size="lg" header-bg-variant="secondary" header-text-variant="white" hide-footer>
      <BenutzerAnlegen @updateUserToast="emitToast"/>
    </b-modal>
  </div>
</template>

<script>
import BenutzerKontoBearbeiten from "./BenutzerKontoBearbeiten";
import BenutzerAnlegen from "./BenutzerAnlegen";
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'BenutzerTable',
  components: {
    BenutzerKontoBearbeiten,
    BenutzerAnlegen
  },
  computed: mapGetters(['alleBenutzer', 'benutzerStatus']),
  methods: {
    ...mapActions(['getAllBenutzer', 'updateBenutzer', 'adminDeleteBenutzer', 'resetAdminBenutzerData']),
    saveChanges(userId) {
      let user = this.alleBenutzer.filter(u => u.id === userId)[0];

      this.updateBenutzer(user)
        .then(() => {
          const toastData = {
            title: "",
            msg: "Die Änderungen wurden gespeichert.",
            variant: "success"
          };

          if (this.benutzerStatus.errMsg) {
            toastData.title = "Es ist etwas schief gelaufen.";
            toastData.msg = this.benutzerStatus.errMsg;
            toastData.variant = "danger";
          }

          this.$emit('updateUserToast', toastData)
        })
    },
    updBenutzer(user) {
      this.benutzer = user;
      this.$bvModal.show(`benutzerBearbeiten`);
    },
    emitToast (toastData) {
      this.$emit("updateUserToast", toastData)
    },
    benutzerLoeschen (userId) {
      if (
        confirm("Sind Sie sicher, dass sie das Konto entgülig löschen wollen?")
      ) {
        this.adminDeleteBenutzer(userId).then(() => {
          const toastData = {
            title: "",
            msg: "Das Benutzerkonto wurde erfolgreich gelöscht.",
            variant: "success"
          };
          if (this.benutzerStatus.errMsg) {
            toastData.title = "Es ist etwas schief gelaufen.";
            toastData.msg = this.benutzerStatus.errMsg;
            toastData.variant = "danger";
          }

          this.$emit('updateUserToast', toastData)
        });
      }
    }
  },
  data() {
    return {
      fields: [
        { key: "active", sortable: true, label: "Aktiviert" },
        { key: "isAdmin", sortable: true, label: "Admin" },
        { key: "id", sortable: true, label: "ID" },
        { key: "anmeldename", sortable: true, label: "Anmeldename"},
        { key: "vorname", sortable: true, label: "Vorname" },
        { key: "name", sortable: true, label: "Name" },
        { key: "buttons", label: "Bearbeiten" }
      ],
      benutzer: {}
    };
  }
}
</script>

<style>
</style>
